import SmallBoxChart from "./SmallBoxChart";

const cloneChildMap = (childs = {}) => {
  const result = {};
  Object.keys(childs || {}).forEach((key) => {
    const list = childs[key];
    result[key] = Array.isArray(list) ? [...list] : [];
  });
  return result;
};

const filterChildren = (childIds = [], details = {}, originalElems = []) => {
  if (!originalElems.length) return childIds;
  return childIds.filter((childId) => {
    const childDetail = details[childId];
    if (!childDetail) return false;
    if (childDetail.level > 3) return true;
    return originalElems.indexOf(childId) < 0;
  });
};

const TreeRole = (
  data,
  defaultLevel = 0,
  contentList = [],
  visited = new Set()
) => {
  if (!data.user_elems || data.user_elems.length === 0) {
    return [];
  }

  const originalElems = Array.isArray(data.ori_user_elems)
    ? [...data.ori_user_elems]
    : data.user_id === ""
    ? [...data.user_elems]
    : [];

  const details = data.user_details || {};
  const childs = cloneChildMap(data.user_childs);
  const userId = data.user_id || "";
  const shouldFilter = userId === "" && originalElems.length > 0;
  const countUserChildrens = data.count_user_childrens || {};
  const isShowFullnameAndPosition = data.isShowFullnameAndPosition ?? false;
  const userLevels = data.user_levels;

  const remainingElems = [...data.user_elems];
  const queues = [];
  let elem = remainingElems.shift() ?? null;
  if (elem !== null) queues.push(elem);

  let level = typeof defaultLevel === "number" ? defaultLevel : 0;
  let loop = 0;
  const maxLoop = 2000;

  while (elem !== null && queues.length > 0 && loop <= maxLoop) {
    // console.log("elem=", elem);

    if (!details[elem]) break;

    // กัน cycle/ซ้ำ
    if (visited.has(elem)) {
      queues.shift();
      elem = queues[0] ?? null;
      continue;
    }
    visited.add(elem);

    loop += 1;
    level += 1;

    const countUserChildren = countUserChildrens[elem] ?? 0;
    const hasChildren = countUserChildren > 0;

    contentList.push("<li>");
    contentList.push(
      SmallBoxChart(details[elem], [], [], "role", {
        level,
        user_id: userId,
        countUserChildren,
        isShowFullnameAndPosition })
    );

    if (shouldFilter && hasChildren) {
      childs[elem] = filterChildren(childs[elem], details, originalElems);
    }

    if (Array.isArray(childs[elem]) && childs[elem].length > 0) {
      // ตัดลูกที่เคยผ่านแล้ว
      childs[elem] = childs[elem].filter((id) => !visited.has(id));
      if (childs[elem].length > 0) {
        contentList.push("<ol>");
        queues.unshift(childs[elem][0]);
        elem = queues[0];
        continue;
      }
    }

    contentList.push("</li>");
    let nextElem = null;
    const snapshot = [...queues];

    for (const queueItem of snapshot) {
      if (
        shouldFilter &&
        Array.isArray(childs[queueItem]) &&
        childs[queueItem].length
      ) {
        childs[queueItem] = filterChildren(
          childs[queueItem],
          details,
          originalElems
        );
      }

      if (Array.isArray(childs[queueItem]) && childs[queueItem].length > 0) {
        // ตัดลูกที่เคยผ่านแล้ว
        childs[queueItem] = childs[queueItem].filter((id) => !visited.has(id));
        if (childs[queueItem].length > 0) {
          queues.unshift(childs[queueItem][0]);
          nextElem = queues[0];
          break;
        }
      }

      if (elem !== queueItem) contentList.push("</ol></li>");

      queues.shift();

      let parentQueue = details[queueItem] && details[queueItem].approver_id;

      if (parentQueue == null) {
        const { employed_by: emp, level } = details[queueItem] || {};
        parentQueue = level > 1 ? userLevels?.[emp]?.[level - 1]?.[0] : null;
        if (parentQueue == null) break;
      }

      if (Array.isArray(childs[parentQueue]) && childs[parentQueue].length) {
        childs[parentQueue] = childs[parentQueue].filter(
          (child) => child !== queueItem
        );
      }

      level -= 1;
    }

    elem = nextElem;
  }

  if (remainingElems.length > 0) {
    return TreeRole(
      { ...data, user_elems: remainingElems, ori_user_elems: originalElems },
      defaultLevel,
      contentList,
      visited
    );
  }

  return contentList;
};

export default TreeRole;

